export const TABS = {
	tuttopost: 0,
	econt: 1,
}
